var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { faDownload, faSearch, faTimes, faUndo } from "@fortawesome/pro-regular-svg-icons";
import { faFilter, faInfoCircle, faSearch as faSearchSolid } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TableView from "@yodlee/common-components/dist/components/table-view";
import { ResponsiveEnums } from "@yodlee/common-components/dist/types/enumerations";
import { NotificationUtils, TableUtils } from "@yodlee/common-components/dist/utilities";
import { Button, Checkbox, Col, Divider, Icon, Input, message, Radio, Row, Select, Spin, Tooltip } from "antd";
import { saveAs } from "file-saver";
import { cloneDeep } from "lodash";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import Highlighter from "react-highlight-words";
import MediaQuery from "react-responsive";
import { NOTIFICATION_ACTION_TYPE } from "../../types/enumerations/notifications";
import { DataUtils, NotfUtils } from "../../utilities";
var initialPagination = {
    defaultPageSize: 50,
    defaultCurrent: 1,
    pageSizeOptions: ["50", "100", "200"],
    showSizeChanger: true,
    showQuickJumper: true,
    current: 1,
    pageSize: 50
};
var defaultPreferences = { preferences: { widgets: [] } };
var CONTAINER_TYPE = "widgets", CONTAINER_ID = "notf-subs-list-wdgt", TABLE_ID = "notf-subs-list";
var SubscriptionList = function (_a) {
    var _b, _c, _d, _e;
    var authentication = _a.authentication, suffix = _a.suffix, header = _a.header, extra = _a.extra, shouldUpdate = _a.shouldUpdate, didUpdate = _a.didUpdate, onAction = _a.onAction, onView = _a.onView;
    var _f = useState(), systemConfig = _f[0], setSystemConfig = _f[1];
    var _g = useState(initialPagination), pagination = _g[0], setPagination = _g[1];
    var _h = useState(), subscriptionList = _h[0], setSubscriptionList = _h[1];
    var _j = useState(), tablePreferenceData = _j[0], setTablePreferenceData = _j[1];
    var _k = useState(), columnMap = _k[0], setColumnMap = _k[1];
    var _l = useState(false), filtersTouched = _l[0], setFiltersTouched = _l[1];
    var _m = useState(false), isActionInProgress = _m[0], setIsActionInProgress = _m[1];
    var searchFilterRefs = useRef({});
    var searchFilterKeysRef = useRef({});
    var inputGlobalSearchRef = useRef();
    var initialMountComplete = useRef(false);
    useEffect(function () {
        if (!initialMountComplete.current)
            return;
        getTableListData(pagination, searchFilterKeysRef.current);
    }, [(_b = authentication.selectedBrand) === null || _b === void 0 ? void 0 : _b.id]);
    useEffect(function () {
        if (!initialMountComplete.current) {
            if (shouldUpdate) {
                didUpdate && didUpdate();
            }
            return;
        }
        if (shouldUpdate) {
            didUpdate && didUpdate();
            getTableListData(pagination, searchFilterKeysRef.current);
        }
    }, [shouldUpdate]);
    useEffect(function () {
        DataUtils.systemConfig(authentication).get().then(function (response) {
            setSystemConfig(response);
        });
        var parsedPrefData = undefined;
        DataUtils.preference(authentication).get().then(function (response) {
            var prefResp = response === null || response === void 0 ? void 0 : response.preference;
            try {
                parsedPrefData = JSON.parse(prefResp || "{}");
            }
            catch (e) { }
        }).finally(function () {
            mapSavedPreferencesToTable(parsedPrefData || __assign({}, defaultPreferences));
        });
        if (!initialMountComplete.current)
            initialMountComplete.current = true;
    }, []);
    var mapSavedPreferencesToTable = function (preferences) {
        var tableFilters = undefined, localColumnMap = undefined;
        var listTable = TableUtils.getRequiredTable(cloneDeep(preferences), CONTAINER_TYPE, CONTAINER_ID, TABLE_ID);
        if (listTable) {
            localColumnMap = TableUtils.columnsToMap(listTable === null || listTable === void 0 ? void 0 : listTable.columns);
            var sortedCol = NotfUtils.sortedColumnDetails(localColumnMap === null || localColumnMap === void 0 ? void 0 : localColumnMap.columnMap);
            tableFilters = __assign(__assign({}, localColumnMap === null || localColumnMap === void 0 ? void 0 : localColumnMap.filteredFields), { sortedBy: sortedCol === null || sortedCol === void 0 ? void 0 : sortedCol.key, sortOrder: sortedCol === null || sortedCol === void 0 ? void 0 : sortedCol.order });
            setColumnMap(localColumnMap === null || localColumnMap === void 0 ? void 0 : localColumnMap.columnMap);
            setTablePreferenceData(listTable);
            searchFilterKeysRef.current = tableFilters;
        }
        else {
            setTablePreferenceData({});
        }
        getTableListData(__assign(__assign({}, initialPagination), listTable === null || listTable === void 0 ? void 0 : listTable.pagination), tableFilters);
    };
    var getTableListData = function (pagination, filters) {
        setSubscriptionList(undefined);
        var formattedFilters = NotfUtils.filterFormatter(filters);
        DataUtils.users(authentication).get(__assign({ pageNumber: pagination.current, pageSize: pagination.pageSize }, formattedFilters)).then(function (response) {
            setSubscriptionList((response === null || response === void 0 ? void 0 : response.data) || []);
            setPagination(__assign(__assign({}, pagination), { total: response === null || response === void 0 ? void 0 : response.totalCount }));
        }).catch(function () {
            setSubscriptionList([]);
            setPagination(__assign(__assign({}, pagination), { total: 0 }));
        });
    };
    var searchBar = function (type) { return (React.createElement(Input, { className: type === "COMPACT" ? "ghost-input" : "", autoFocus: type === "COMPACT", style: { width: type === "COMPACT" ? "100%" : undefined, maxWidth: type === "FULL" ? "300px" : undefined }, onPressEnter: function (e) {
            if (e.target.value)
                getTableListData(pagination, __assign(__assign({}, searchFilterKeysRef.current), { name: e.target.value }));
            else
                getTableListData(pagination, searchFilterKeysRef.current);
        }, ref: inputGlobalSearchRef, suffix: type === "COMPACT" &&
            React.createElement(Icon, { onClick: function () { }, className: "color-pink cursor-pointer", component: function () { return React.createElement(FontAwesomeIcon, { icon: faTimes }); } }), prefix: React.createElement(Icon, { className: "color-gray-5", component: function () { return React.createElement(FontAwesomeIcon, { icon: faSearch }); } }), placeholder: "Search by name" })); };
    var onExport = function () {
        var hide = message.loading('Preparing file...', 0);
        var formattedFilters = NotfUtils.filterFormatter(searchFilterKeysRef.current);
        DataUtils.users(authentication).get(__assign(__assign({}, formattedFilters), { view: "export" }), undefined, true).then(function (resp) {
            saveAs(new Blob([resp], { type: "text/csv;charset=utf-8" }), "Export Subscriptions - ".concat(moment(new Date()).format("Do MMM, YYYY"), ".csv"));
        }).finally(function () { return hide(); });
    };
    var onTablePreferenceChanges = function (preferenceUpdates) {
        DataUtils.preference(authentication).get().then(function (response) {
            var _a;
            var existingUserPref = JSON.parse((response === null || response === void 0 ? void 0 : response.preference) || "{}");
            var formattedWidgets = TableUtils.formatTablePreferences(cloneDeep(existingUserPref), preferenceUpdates, CONTAINER_TYPE, CONTAINER_ID, TABLE_ID);
            var currentPreferences = cloneDeep(existingUserPref) || {};
            if (currentPreferences === null || currentPreferences === void 0 ? void 0 : currentPreferences.preferences)
                currentPreferences.preferences[CONTAINER_TYPE] = formattedWidgets;
            else
                currentPreferences.preferences = (_a = {}, _a[CONTAINER_TYPE] = formattedWidgets, _a);
            var updatedColumnsMap = TableUtils.getUpdatedColumnsMap(columnMap, preferenceUpdates);
            setColumnMap(updatedColumnsMap);
            // setUserPreferencData(currentPreferences);
            DataUtils.preference(authentication).put(currentPreferences);
        });
    };
    var headerView = function (matches) { return (React.createElement(React.Fragment, null, header &&
        React.createElement(React.Fragment, null,
            React.createElement("span", { className: "margin-left-xs" }, header)))); };
    var suffixView = function (matches) {
        return React.createElement(React.Fragment, null,
            React.createElement(React.Fragment, null, matches ?
                searchBar("FULL") :
                React.createElement(Tooltip, { title: "Search", placement: "bottomLeft" },
                    React.createElement(Button, { type: "link", className: "no-padding no-margin", onClick: function () { } },
                        React.createElement(Icon, { className: "font-size-xl", component: function () { return React.createElement(FontAwesomeIcon, { icon: faSearch }); } })))),
            React.createElement("span", { className: "margin-right-xs" }),
            React.createElement("span", { className: "margin-right-xs" }),
            matches &&
                React.createElement(React.Fragment, null, headerView(matches)),
            suffix &&
                React.createElement(React.Fragment, null,
                    React.createElement("span", { className: "margin-left-xs" }, suffix)));
    };
    var handleSearch = function (selectedKeys, confirm, key) {
        var _a;
        confirm();
        var newFilters = __assign(__assign({}, searchFilterKeysRef.current), (_a = {}, _a[key] = selectedKeys[0], _a));
        searchFilterKeysRef.current = newFilters;
        getTableListData(__assign(__assign({}, pagination), { current: initialPagination.current }), newFilters);
    };
    var handleReset = function (clearFilters, key) {
        var _a;
        clearFilters();
        var newFilters = __assign(__assign({}, searchFilterKeysRef.current), (_a = {}, _a[key] = undefined, _a));
        searchFilterKeysRef.current = newFilters;
        getTableListData(__assign(__assign({}, pagination), { current: initialPagination.current }), newFilters);
    };
    var fixedOptionsFilterProps = function (key, filterOptions, singleSelection) { return ({
        filterDropdown: function (_a) {
            var setSelectedKeys = _a.setSelectedKeys, selectedKeys = _a.selectedKeys, confirm = _a.confirm, clearFilters = _a.clearFilters;
            return (React.createElement("div", null,
                React.createElement("div", { className: "padding-xs", style: { maxHeight: 300, overflowY: "auto" } }, singleSelection ?
                    React.createElement(Radio.Group, { onChange: function (e) { return setSelectedKeys([e.target.value]); }, value: selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys[0] }, (filterOptions || []).map(function (opt) {
                        return React.createElement(React.Fragment, null,
                            React.createElement(Radio, { className: "padding-bottom-xs", key: opt.name, value: opt.id }, opt.name),
                            React.createElement("br", null));
                    }))
                    :
                        React.createElement(Checkbox.Group, { value: selectedKeys, onChange: function (values) {
                                setSelectedKeys(values);
                            } }, (filterOptions || []).map(function (opt) {
                            return React.createElement(React.Fragment, null,
                                React.createElement(Checkbox, { className: "padding-bottom-xs", key: opt.id, value: opt.id }, opt.name),
                                React.createElement("br", null));
                        }))),
                React.createElement(Divider, { type: "horizontal", className: "no-margin" }),
                React.createElement(Row, { className: "padding-xs" },
                    React.createElement(Col, { span: 16 },
                        React.createElement(Button, { type: "link", onClick: function () {
                                var newSearchFilterKeys = __assign({}, searchFilterKeysRef.current);
                                delete newSearchFilterKeys[key];
                                searchFilterKeysRef.current = newSearchFilterKeys;
                                getTableListData(__assign(__assign({}, pagination), { current: initialPagination.current }), newSearchFilterKeys);
                                clearFilters();
                            } },
                            React.createElement(FontAwesomeIcon, { icon: faUndo }),
                            React.createElement("span", { className: "margin-left-xs" }),
                            React.createElement("b", null, "Revert to default"))),
                    React.createElement(Col, { span: 8, style: { textAlign: "right" } },
                        React.createElement(Button, { type: "primary", onClick: function () {
                                var _a;
                                var newSearchFilterKeys = __assign(__assign({}, searchFilterKeysRef.current), (_a = {}, _a[key] = selectedKeys, _a));
                                searchFilterKeysRef.current = newSearchFilterKeys;
                                getTableListData(__assign(__assign({}, pagination), { current: initialPagination.current }), newSearchFilterKeys);
                                confirm();
                            } }, "Apply")))));
        },
        filters: (filterOptions).map(function (option) { return ({ text: option.name, value: option.id.toString() }); }),
        filterIcon: React.createElement(Icon, { component: function () { return React.createElement(FontAwesomeIcon, { icon: faFilter }); } }),
        onClearFilter: function () { return handleReset(function () { }, key); },
    }); };
    var searchFilterProps = function (dataIndex, title, key, getValue, render) {
        if (getValue === void 0) { getValue = function (item) { return (item || "").toString(); }; }
        return ({
            filterDropdown: function (_a) {
                var setSelectedKeys = _a.setSelectedKeys, selectedKeys = _a.selectedKeys, confirm = _a.confirm, clearFilters = _a.clearFilters;
                return (React.createElement("div", { className: "padding-xs" },
                    React.createElement(Input, { className: "no-margin no-padding", ref: function (node) {
                            searchFilterRefs.current[key] = node;
                        }, placeholder: "Search by ".concat(title.toLowerCase()), value: selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys[0], onChange: function (e) {
                            var value = e.target.value;
                            setSelectedKeys(value ? [e.target.value] : []);
                            !value && handleReset(clearFilters, key);
                        }, onPressEnter: function () { return handleSearch(selectedKeys, confirm, key); }, style: { width: 188, marginBottom: 8, display: 'block' }, allowClear: true })));
            },
            filterIcon: React.createElement(Icon, { component: function () { return React.createElement(FontAwesomeIcon, { icon: faSearchSolid }); } }),
            onFilter: function (value, record) {
                return true;
            },
            onFilterDropdownVisibleChange: function (visible) {
                if (visible) {
                    setTimeout(function () { return searchFilterRefs.current[key].select(); });
                }
            },
            onClearFilter: function () { return handleReset(function () { }, key); },
            render: render ? render : function (text) {
                var _a;
                var wordsToHighLight = undefined, currentFilter = (_a = searchFilterKeysRef.current) === null || _a === void 0 ? void 0 : _a[key];
                if (currentFilter)
                    wordsToHighLight = Array.isArray(currentFilter) ? currentFilter : [currentFilter];
                return text && wordsToHighLight ?
                    React.createElement(Highlighter, { highlightStyle: { backgroundColor: 'yellow', padding: 0 }, searchWords: wordsToHighLight, autoEscape: true, textToHighlight: getValue(text) }) :
                    React.createElement(Tooltip, { title: getValue(text), placement: "bottomLeft" }, getValue(text));
            }
        });
    };
    var columns = systemConfig ? [
        __assign({ title: "Email", key: "email", dataIndex: "user.email", width: 150, minWidth: 150, sorter: function () { return 0; }, ellipsis: true }, searchFilterProps("email", "Email", "email", undefined, function (text, record) {
            return React.createElement("span", { onClick: function () { return onView(record); }, className: "color-blue-5 cursor-pointer" },
                React.createElement(Tooltip, { placement: "bottomLeft", title: text },
                    React.createElement("b", null, text)));
        })),
        __assign(__assign({ title: "Name", key: "name", dataIndex: "user", width: 120, minWidth: 120, sorter: function () { return 0; }, ellipsis: true }, searchFilterProps("user", "Name", "name")), { render: function (userName, record) {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                return React.createElement("span", { onClick: function () { return onView(record); }, className: "color-blue-5 cursor-pointer" },
                    React.createElement(Tooltip, { placement: "bottomLeft", title: ((_b = (_a = record === null || record === void 0 ? void 0 : record.user) === null || _a === void 0 ? void 0 : _a.firstName) !== null && _b !== void 0 ? _b : "") + " " + ((_d = (_c = record === null || record === void 0 ? void 0 : record.user) === null || _c === void 0 ? void 0 : _c.lastName) !== null && _d !== void 0 ? _d : "") },
                        React.createElement("b", null, ((_f = (_e = record === null || record === void 0 ? void 0 : record.user) === null || _e === void 0 ? void 0 : _e.firstName) !== null && _f !== void 0 ? _f : "") + " " + ((_h = (_g = record === null || record === void 0 ? void 0 : record.user) === null || _g === void 0 ? void 0 : _g.lastName) !== null && _h !== void 0 ? _h : ""))));
            } }),
        __assign({ title: "Username", key: "userName", dataIndex: "user.userName", width: 120, minWidth: 120, sorter: function () { return 0; } }, searchFilterProps("user.userName", "Username", "userName")),
        {
            title: "Cobrand",
            key: "brandId",
            dataIndex: "brand.id",
            width: 150,
            minWidth: 150,
            sorter: function () { return 0; },
            ellipsis: true,
            filterIcon: React.createElement(Icon, { component: function () { return React.createElement(FontAwesomeIcon, { icon: faFilter }); } }),
            filters: (_e = __spreadArray(__spreadArray([], (((_c = systemConfig === null || systemConfig === void 0 ? void 0 : systemConfig.brandInfos) === null || _c === void 0 ? void 0 : _c.PRODUCTION) || []), true), (((_d = systemConfig === null || systemConfig === void 0 ? void 0 : systemConfig.brandInfos) === null || _d === void 0 ? void 0 : _d.STAGE) || []), true)) === null || _e === void 0 ? void 0 : _e.map(function (cob) { return ({ text: cob.name, value: cob.id + "-" + cob.dataBase }); }),
            onClearFilter: function () { return handleReset(function () { }, "brandId"); },
            filterDropdown: function (_a) {
                var _b, _c;
                var setSelectedKeys = _a.setSelectedKeys, selectedKeys = _a.selectedKeys, confirm = _a.confirm, clearFilters = _a.clearFilters;
                return React.createElement(CobrandListFilter, { confirm: confirm, handleReset: handleReset, handleSearch: handleSearch, selectedKeys: selectedKeys, setSelectedKeys: setSelectedKeys, clearFilters: clearFilters, prodCobrandList: (_b = systemConfig === null || systemConfig === void 0 ? void 0 : systemConfig.brandInfos) === null || _b === void 0 ? void 0 : _b.PRODUCTION, stageCobrandList: (_c = systemConfig === null || systemConfig === void 0 ? void 0 : systemConfig.brandInfos) === null || _c === void 0 ? void 0 : _c.STAGE });
            },
            render: function (brandId, record) {
                var _a, _b;
                return React.createElement("div", { style: { display: "flex", flexDirection: "column", marginTop: -8, marginBottom: -8 } },
                    React.createElement("div", null, ((_a = record === null || record === void 0 ? void 0 : record.brand) === null || _a === void 0 ? void 0 : _a.name) || "N/A"),
                    React.createElement("div", { className: "color-gray-5" }, "(".concat((_b = record === null || record === void 0 ? void 0 : record.brand) === null || _b === void 0 ? void 0 : _b.id, ")")));
            }
        },
        __assign({ title: "Phone", key: "phone", dataIndex: "user.phone.number", width: 150, minWidth: 150, sorter: function () { return 0; }, ellipsis: true }, searchFilterProps("phone", "Phone", "phone")),
        __assign({ title: "Timezone", key: "timezone", dataIndex: "timezone.name", width: 150, minWidth: 150, ellipsis: true, sorter: function () { return 0; } }, fixedOptionsFilterProps("timezone", (systemConfig === null || systemConfig === void 0 ? void 0 : systemConfig.timezone) || [], true)),
        __assign({ title: "Environment", key: "environment", dataIndex: "environment", width: 150, minWidth: 150, sorter: function () { return 0; }, ellipsis: true }, fixedOptionsFilterProps("environment", [{ name: "Stage", id: "stage" }, { name: "Production", id: "production" }], true)),
        __assign({ title: "My Yodlee user", key: "isMyYodleeUser", dataIndex: "isMyYodleeUser", width: 150, minWidth: 150, sorter: function () { return 0; }, ellipsis: true, render: function (data, record) { return React.createElement("span", null, data === true ? "Yes" : "No"); } }, fixedOptionsFilterProps("isMyYodleeUser", [{ name: "Yes", id: "true" }, { name: "No", id: "false" }], true)),
        __assign({ title: "Roles", key: "roles", dataIndex: "roles", width: 150, minWidth: 150, sorter: function () { return 0; }, ellipsis: true, render: function (data, record) { return React.createElement("span", null,
                React.createElement(Tooltip, { placement: "bottomLeft", title: (data || []).map(function (itm) { return itm === null || itm === void 0 ? void 0 : itm.name; }).join(",\n") }, (data || []).map(function (itm) { return itm === null || itm === void 0 ? void 0 : itm.name; }).join(","))); } }, fixedOptionsFilterProps("roles", (systemConfig === null || systemConfig === void 0 ? void 0 : systemConfig.roles) || [])),
        {
            title: "Account created",
            key: "created",
            dataIndex: "created",
            width: 150,
            minWidth: 150,
            render: function (data, record) {
                return React.createElement("span", null,
                    React.createElement(Tooltip, { style: { fontSize: "10px" }, placement: "bottomLeft", title: data ? moment(data).calendar() : undefined }, data ? moment(data).calendar() : "N/A"));
            },
            ellipsis: true,
            sorter: function () { return 0; },
        },
        {
            title: "Last modified",
            key: "updated",
            dataIndex: "updated",
            width: 150,
            minWidth: 150,
            render: function (data, record) {
                return React.createElement("span", null,
                    React.createElement(Tooltip, { style: { fontSize: "10px" }, placement: "bottomLeft", title: data ? moment(data).calendar() : undefined }, data ? moment(data).calendar() : "N/A"));
            },
            ellipsis: true,
            sorter: function () { return 0; },
        },
    ] : [];
    var quickActions = [
        {
            name: "Delete",
            key: "delete",
            onClick: function (records) {
                setIsActionInProgress(true);
                DataUtils.users(authentication).delete({ userIds: records.map(function (rec) { return rec.id; }) }, undefined)
                    .then(function (resp) {
                    NotificationUtils.success("Success", "Delete request successful.");
                    getTableListData(pagination, searchFilterKeysRef.current);
                }).finally(function () { return setIsActionInProgress(false); });
                onAction(NOTIFICATION_ACTION_TYPE.DELETE, records);
            }
        }
    ];
    var formattedColumns = NotfUtils.formatColumns(columns, columnMap, undefined, filtersTouched);
    return React.createElement(MediaQuery, { minWidth: ResponsiveEnums.SCREEN_SIZE.MD, minDeviceWidth: ResponsiveEnums.SCREEN_SIZE.MD }, function (matches) {
        var _a;
        return systemConfig && tablePreferenceData ? React.createElement(React.Fragment, null,
            React.createElement(TableView, { showClearFilter: true, onClearAllFilter: function (isLocale) {
                    if (isLocale) {
                        inputGlobalSearchRef.current.setValue("");
                    }
                    var sortFilters = { sortedBy: searchFilterKeysRef === null || searchFilterKeysRef === void 0 ? void 0 : searchFilterKeysRef.current["sortedBy"], sortOrder: searchFilterKeysRef === null || searchFilterKeysRef === void 0 ? void 0 : searchFilterKeysRef.current["sortOrder"] };
                    searchFilterKeysRef.current = sortFilters;
                    getTableListData(__assign(__assign({}, pagination), { current: initialPagination.current }), sortFilters);
                }, locale: { emptyText: "We can't find any subscriptions." }, suffix: suffixView(matches), 
                // prefix={prefix}
                extra: React.createElement(React.Fragment, null,
                    extra,
                    React.createElement(Button, { type: "link", onClick: function () { return onExport(); } },
                        React.createElement(Icon, { className: "font-size-lg", component: function () { return React.createElement(FontAwesomeIcon, { icon: faDownload }); } }),
                        React.createElement("span", { className: "margin-left-xs" }),
                        "Export")), 
                // header={headerView(matches)}
                // footer={footer}
                // name={LabelConfigs.SERVICE_REQUEST}
                onRowSelect: function (ids) {
                }, loading: !subscriptionList || isActionInProgress, quickActions: quickActions, title: React.createElement(Input, { className: "", 
                    // autoFocus={type === "COMPACT"}
                    style: { width: false ? "100%" : undefined, maxWidth: true ? "300px" : undefined }, onPressEnter: function (e) {
                        // onGlobalSearch(e.target.value)
                    }, suffix: false &&
                        React.createElement(Icon, { onClick: function () { }, className: "color-pink cursor-pointer", component: function () { return React.createElement(FontAwesomeIcon, { icon: faTimes }); } }), prefix: React.createElement(Icon, { className: "color-gray-5", component: function () { return React.createElement(FontAwesomeIcon, { icon: faSearch }); } }), placeholder: "Search by service request #" }), fixedColumns: ["email"], data: subscriptionList || [], getRowKey: function (data) { var _a; return (_a = data === null || data === void 0 ? void 0 : data.id) === null || _a === void 0 ? void 0 : _a.toString(); }, columns: formattedColumns === null || formattedColumns === void 0 ? void 0 : formattedColumns.allColumns, rowDensity: tablePreferenceData === null || tablePreferenceData === void 0 ? void 0 : tablePreferenceData.density, selectedColumnKeys: ((_a = formattedColumns === null || formattedColumns === void 0 ? void 0 : formattedColumns.visibleColumns) === null || _a === void 0 ? void 0 : _a.length) > 0 ? formattedColumns === null || formattedColumns === void 0 ? void 0 : formattedColumns.visibleColumns : undefined, defaultColumnKeys: ["email", "userName", "name", "cobrand", "phone", "timezone"], onPreferenceChanges: function (preference) { return onTablePreferenceChanges(__assign(__assign({}, preference), { pagination: __assign(__assign({}, preference.pagination), { pageSize: 50 }) })); }, 
                // onExport={() => AmplitudeEventsUtils.srListExport()}
                pagination: pagination, onChange: function (newPagination, filters, sorter) {
                    var _a, _b;
                    if (!filtersTouched)
                        setFiltersTouched(true);
                    var hasSortOrderChanged = (searchFilterKeysRef === null || searchFilterKeysRef === void 0 ? void 0 : searchFilterKeysRef.current["sortedBy"]) !== ((_a = sorter === null || sorter === void 0 ? void 0 : sorter.column) === null || _a === void 0 ? void 0 : _a.key) || (searchFilterKeysRef === null || searchFilterKeysRef === void 0 ? void 0 : searchFilterKeysRef.current["sortOrder"]) !== (sorter === null || sorter === void 0 ? void 0 : sorter.order);
                    var newFilters = __assign({}, searchFilterKeysRef.current);
                    if (hasSortOrderChanged) {
                        newFilters = __assign(__assign({}, newFilters), { sortedBy: (_b = sorter === null || sorter === void 0 ? void 0 : sorter.column) === null || _b === void 0 ? void 0 : _b.key, sortOrder: sorter === null || sorter === void 0 ? void 0 : sorter.order });
                        searchFilterKeysRef.current = newFilters;
                    }
                    if (hasSortOrderChanged || (newPagination && (newPagination.current !== pagination.current || newPagination.pageSize !== pagination.pageSize))) {
                        getTableListData(__assign(__assign({}, pagination), newPagination), newFilters);
                    }
                } }))
            :
                React.createElement(Row, { type: "flex", justify: "center", align: "middle", style: { height: "80vh" } },
                    React.createElement(Col, null,
                        React.createElement(Spin, { size: "large", indicator: React.createElement(Icon, { type: "loading" }) })));
    });
};
export default SubscriptionList;
var CobrandListFilter = function (_a) {
    var _b;
    var setSelectedKeys = _a.setSelectedKeys, selectedKeys = _a.selectedKeys, handleSearch = _a.handleSearch, confirm = _a.confirm, handleReset = _a.handleReset, clearFilters = _a.clearFilters, stageCobrandList = _a.stageCobrandList, prodCobrandList = _a.prodCobrandList;
    var _c = useState(), selectedVal = _c[0], setSelectedVal = _c[1];
    var _d = useState(), matchedOptions = _d[0], setMatchedOptions = _d[1];
    var columnKey = "brandId";
    var onSearch = function (value) {
        var result = NotfUtils.cobrandFilterListFormatter(stageCobrandList, prodCobrandList, value, selectedVal);
        setMatchedOptions(cloneDeep(result));
    };
    useEffect(function () {
        setSelectedVal(selectedKeys);
        var result = NotfUtils.cobrandFilterListFormatter(stageCobrandList, prodCobrandList, "", selectedKeys);
        setMatchedOptions(result);
    }, [stageCobrandList, prodCobrandList, selectedKeys]);
    return React.createElement("div", { className: "padding-xs" },
        React.createElement(Select, { autoFocus: true, showSearch: true, className: "filter-set-autocomp", placeholder: "Search by Cobrand Id/Name", defaultActiveFirstOption: false, showArrow: false, autoClearSearchValue: false, allowClear: true, value: selectedVal, filterOption: false, onSelect: function (selectedValue) {
                setSelectedKeys(selectedValue ? [selectedValue] : []);
                handleSearch([[selectedValue]], confirm, columnKey);
            }, dropdownRender: function (menu) {
                var _a;
                return React.createElement(React.Fragment, null,
                    menu,
                    ((_a = (matchedOptions || [])) === null || _a === void 0 ? void 0 : _a.length) > 100 &&
                        React.createElement(Row, { type: "flex", gutter: 8, className: "font-size-md background-gray-2 no-margin padding-xs" },
                            React.createElement(Col, { span: 2 },
                                React.createElement(FontAwesomeIcon, { icon: faInfoCircle, className: "color-blue-5" })),
                            React.createElement(Col, { span: 22 },
                                "Displaying ",
                                (matchedOptions || []).length > 100 ? 100 : (matchedOptions || []).length,
                                " records. Please search to refine")));
            }, onChange: function (selectedValue) { !selectedValue && handleReset(clearFilters, columnKey); }, onSearch: function (searchedValue) { onSearch(searchedValue); }, style: { width: 250, display: 'block' } }, (_b = (matchedOptions || [])) === null || _b === void 0 ? void 0 : _b.map(function (option, indx) { return indx < 100 ? React.createElement(Select.Option, { style: { overflow: "hidden" }, key: option.id + "-" + option.dataBase, value: option.id + "-" + option.dataBase }, (selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys[0]) === option.id + "-" + option.dataBase
            ?
                React.createElement(Tooltip, { title: "".concat(option.name, " (").concat(option.id, ") [").concat(option.envKey, "]") },
                    React.createElement("div", null, "".concat(option.name, " (").concat(option.id, ") [").concat(option.envKey, "]")))
            :
                React.createElement("div", { style: { display: "flex", flexDirection: "column" } },
                    React.createElement("div", null,
                        React.createElement("b", null, "".concat(option.name))),
                    React.createElement("div", { style: { fontSize: 12 } }, "".concat(option.id, " [").concat(option.envKey, "]"))))
            : null; })));
};
//# sourceMappingURL=index.js.map